<template>
  <div class="wrap">
    <div class="tit">Place Order</div>
    <div style="overflow: hidden;max-height: 132vw;">
      <div style="overflow-y: scroll;max-height: 132vw;">
        <div v-for="item in getCheckGoodList" :key="item.id">
          <div
            style="margin: 4vw 0 4.8vw;border-bottom: 1px solid #EAEAEA;padding-bottom: 4vw;display: flex;align-items: center;">
            <div>
              <img style=" height: 23.467vw; width: 23.467vw; border-radius: 1.333vw; border: 1px solid #D9D9D9;"
                v-lazy="item.imageUrl" />
            </div>
            <div style="margin-left: 4vw;">
              <div style="display: flex;margin-bottom: 2.133vw;">
                <div style="color: #000;width: 38.667vw;">{{ item.skuName }} </div>
                <div style="width: 16vw;height: 4.533vw;margin-left: 0.8vw; line-height: 4.533vw;font-size: 2.667vw;
                        border: 1px solid #333;border-radius: 9.5px;font-weight: bold;text-align: center;">
                  {{ getLabelForStatus(item.proType) }}
                </div>
              </div>
              <p style="color: #959595;font-size: 3.467vw;">UnitPrice： $ {{ item.price }}</p>
              <div style="display: flex;justify-content: space-between;color: #000;">
                <div style="font-size: 3.467vw;">Quantity：<span style="font-weight: bold;font-size: 4.267vw;">{{ item.num
                }}</span></div>
                <div>
                  <span style="color: #000;font-weight: bold;">${{ (item.price * 1000) * item.num / 1000 }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 5.333vw;">
      <div class="info">
        <div class="infotit">
          <div style="display: flex;justify-content: space-between;">
            <div>Personal Info</div>
            <div @click="enterEditMode" v-if="!editMode"
              style="margin-right: 5.867vw;cursor: pointer;font-size: 3.467vw;color: #4583E1;font-weight: normal;">
              <i class="el-icon-edit-outline"></i><span style="text-decoration: underline;"> Edit</span>
            </div>
          </div>
        </div>
        <div style="padding: 6.4vw 5.333vw 8vw;">
          <div>
            <div class="infotits">UserName</div>
            <div v-if="!editMode" class="infodetails">{{ personalInfo.nickName }}</div>
            <el-form v-else ref="personalInfo" :model="personalInfo">
              <el-form-item prop="nickName" style="width: 73.333vw;" :rules="[
                { required: true, message: 'Please enter your nickName', trigger: 'blur' },
              ]">
                <el-input v-model="personalInfo.nickName"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div style="margin-top: 4.533vw;">
            <div class="infotits">Email</div>
            <div v-if="!editMode" class="infodetails">{{ personalInfo.email }}</div>
            <el-form v-else ref="personalInfo" :model="personalInfo">
              <el-form-item prop="email" style="width: 73.333vw;" :rules="[
                { required: true, message: 'Please enter your email address', trigger: 'blur' },
                { type: 'email', message: 'Please enter the correct email address', trigger: ['blur', 'change'] }
              ]">
                <el-input v-model="personalInfo.email"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div style="margin-top: 4.533vw;">
            <div class="infotits">Phone Number</div>
            <div v-if="!editMode" class="infodetails">{{ personalInfo.phone }}</div>
            <el-form v-else ref="personalInfo" :model="personalInfo">
              <el-form-item prop="phone" style="width: 73.333vw;" :rules="[
                { required: true, message: 'Please enter your phone', trigger: 'blur' },
              ]">
                <el-input v-model="personalInfo.phone"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div style="margin-top: 4.533vw;">
            <div class="infotits">Company</div>
            <div class="infodetails">{{ personalInfo.companyName }}</div>
          </div>
          <div v-if="editMode" style="display: flex;justify-content: right;">
            <button @click="submitForm('personalInfo')" class="save">Save</button>
          </div>
        </div>
      </div>
      <div class="info" style="margin-top: 5.333vw;">
        <div class="infotit">
          Shipping details
        </div>
        <div style="padding: 3.365vw 5.333vw 5.6vw;">
          <div :class="{ 'grayed-out': isGrayedOut }">
            <div style="font-size: 3.2vw;color: #959595;margin-bottom: 1.6vw;">Please select a shipping address</div>
            <div class="addlist">
              <div style="height: 43.2vw;overflow: hidden;">
                <div class="scrollable-content">
                  <div v-for="(item, index) in addresses" :key="index" class="adds">
                    <div>
                      <input type="radio" :value="item.id" v-model="selectedItem" />
                    </div>
                    <div style="margin-left: 3.467vw;font-size: 4vw;overflow:hidden;">
                      <p>{{ item.nickName }}</p>
                      <p style="margin-top: 2.133vw;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{
                        item.address }}{{ item.addressTwo }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div @click="handleButtonClick" style="margin-top: 4vw;">
              <img src="../assets/imgs/uploads/Group 391.png" alt="" style="width: 4vw;height: 4vw;">
              <span class="add">Add New Address</span>
            </div>
          </div>
          <div v-if="showOtherArea">
            <el-form :model="address" :hide-required-asterisk="true" ref="address">
              <div>
                <p style="font-size: 3.467vw; margin: 4.533vw 0 1.6vw;">Country/Region</p>
                <el-form-item prop="country" :rules="[
                  { required: true, message: 'country cannot be empty' },
                ]">
                  <el-input v-model="address.country" style="width: 73.333vw;" :validate-event="false"
                    placeholder="Please Select your country/region"></el-input>
                </el-form-item>
              </div>
              <div>
                <p style="font-size: 3.467vw; margin: 4.533vw 0 1.6vw;">City</p>
                <el-form-item prop="city" :rules="[
                  { required: true, message: 'city cannot be empty' },
                ]">
                  <el-input v-model="address.city" style="width: 73.333vw;" :validate-event="false"></el-input>
                </el-form-item>
              </div>
              <div>
                <p style="font-size: 3.467vw; margin: 4.533vw 0 1.6vw;">Address1</p>
                <el-form-item prop="address" :rules="[
                  { required: true, message: 'address1 cannot be empty' },
                ]">
                  <el-input v-model="address.address" style="width: 73.333vw;" :validate-event="false"
                    placeholder="Street address, company name"></el-input>
                </el-form-item>
              </div>
              <div>
                <p style="font-size: 3.467vw; margin: 4.533vw 0 1.6vw;">Address2</p>
                <el-form-item prop="addressTwo">
                  <el-input v-model="address.addressTwo" style="width: 73.333vw;" :validate-event="false"
                    placeholder="Suite, Unit, Building, Floor ect (optional)"></el-input>
                </el-form-item>
              </div>
              <div>
                <p style="font-size: 3.467vw; margin: 4.533vw 0 1.6vw;">ZIP Code</p>
                <el-form-item prop="zipCode">
                  <el-input v-model="address.zipCode" style="width: 73.333vw;" :validate-event="false"
                    placeholder="Or post code"></el-input>
                </el-form-item>
              </div>
              <div>
                <p style="font-size: 3.467vw; margin: 4.533vw 0 1.6vw;">Contact Number</p>
                <el-form-item prop="contactNumber">
                  <el-input v-model="address.contactNumber" style="width: 73.333vw;" :validate-event="false"
                    placeholder="Contact number"></el-input>
                </el-form-item>
              </div>
              <el-checkbox v-model="checked"><span style="font-size: 2.933vw;">Save this shipping infomation for next
                  time</span></el-checkbox>
              <el-form-item style="margin-top: 3.733vw;">
                <div style="display: flex;justify-content: space-between;">
                  <el-button type="primary" @click="backadd" style="width: 26.4vw;">Back</el-button>
                  <el-button @click="submitForm1('address')" class="addnew">Save</el-button>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div style="padding:6.4vw 0 9.067vw; font-size: 4.533vw;">
      <table style="width: 100%;color: #A2A2A2" cellpadding="5">
        <tr>
          <td colspan="2" style="color: black; font-weight: bold;">Price Details</td>
        </tr>
        <tr style="font-size: 3.467vw;">
          <td>Subtotal</td>
          <td style="text-align: right">${{ getTotalPrice }}</td>
        </tr>
        <tr>
          <td colspan="2"><el-button :disabled="isClick" type="primary" style="width: 100%" @click="addOrder()">PLACE
              ORDER</el-button>
          </td>
        </tr>
        <tr>
          <td colspan="2" style="color: #333;font-weight: bold;">
            <div @click="goBack" style="display: flex;justify-content: center;">&lt; Back to Cart</div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      personalInfo: '',
      selectedItem: null,
      addresses: [],
      address: {
        country: '',
        city: '',
        address: '',
        addressTwo: '',
        zipCode: '200000',
        contactNumber: '',
        nickName: '',
        status: '',
        umsId: this.$store.getters.getUser.id
      },
      isGrayedOut: false,
      showOtherArea: false,
      isClick: false,
      editMode: false,
      checked: false
    }
  },
  activated() {
    this.getpersonInfo()
    this.activated1()
    this.defaultadd()
  },
  methods: {
    ...mapActions(["updateShoppingCart", "deleteShoppingCart", "checkAll"]),
    getpersonInfo() {
      this.$axios
        .post("/api/mall/customer/personInfo", {
          id: this.$store.getters.getUser.id
        })
        .then(res => {
          if (res.data.code === 200) {
            this.personalInfo = res.data.data
          }
        })
        .catch(err => {
          return Promise.reject(err);
        });
    },
    defaultadd() {
      this.$axios
        .post("/api/mall/customer/getDefaultAddress", {
          userId: this.$store.getters.getUser.id,
        })
        .then(res => {
          if (res.data.code === 200) {
            if (res.data.data) {
              this.selectedItem = res.data.data.addressId
            }
          }
        })
        .catch(err => {
          return Promise.reject(err);
        });
    },
    activated1() {
      this.$axios
        .post("/api/mall/customer/getAddress", {
          umsId: this.$store.getters.getUser.id
        })
        .then(res => {
          if (res.data.code === 200) {
            this.addresses = []
            this.addresses = res.data.data
          }
        })
        .catch(err => {
          return Promise.reject(err);
        });
    },
    enterEditMode() {
      this.editMode = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editMode = false;
          this.$axios
            .post("/api/mall/customer/saveInfo", this.personalInfo)
          this.$message({
            message: 'Modified successfully',
            type: "success",
          });
        } else {
          return false;
        }
      });
    },
    submitForm1(formName1) {
      if (this.checked === true) {
        this.address.status = 0
      }
      this.$refs[formName1].validate((valid) => {
        if (valid) {
          this.$axios
            .post("/api/mall/customer/saveAddress", this.address)
            .then(res => {
              if (res.data.code === 200) {
                this.activated1()
                this.$message({
                  message: 'Add successfully',
                  type: "success",
                });
                this.address = {}
                this.address.umsId = this.$store.getters.getUser.id
                this.isGrayedOut = false;
                this.showOtherArea = false;
                this.checked = false;
                this.defaultadd()
              }
            })
            .catch(err => {
              return Promise.reject(err);
            });
        } else {
          return false;
        }
      });
    },
    handleButtonClick() {
      this.isGrayedOut = true;
      this.showOtherArea = true;
    },
    backadd() {
      this.isGrayedOut = false;
      this.showOtherArea = false;
    },
    getLabelForStatus(status) {
      var a = status + ''
      switch (a) {
        case '0':
          return this.$t('list.instock');
        case '1':
          return this.$t('list.production');
        case '2':
          return this.$t('list.ordertogether');
        default:
          return 'unknown';
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    addOrder() {
      if (this.selectedItem) {
        this.isClick = true;
        setTimeout(() => {
          this.isClick = false;
        }, 5000);
        let arr = []
        const loading1 = this.$loading({
          lock: true,
          text: 'loading···',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
          customClass: 'custom-loading'
        });
        this.getShoppingCart.map(item => {
          if (item.check) {
            arr.push(item.id)
          }
        })
        const addressId = this.selectedItem
        this.$axios
          .post("/api/mall/order/" + this.$store.getters.getUser.id + '/' + addressId,
            arr)
          .then(res => {
            switch (res.data.code) {
              // “001”代表结算成功
              case 200:
                for (let i = 0; i < arr.length; i++) {
                  // 删除已经结算的购物车商品
                  this.deleteShoppingCart(arr[i]);
                }
                // 提示结算结果
                this.notifySucceed(this.$t('cart.ordered'));
                loading1.close();
                this.$router.push({ path: "/finishedorder" });
                break;
              default:
                // 提示失败信息
                this.notifyError(res.data.message);
                loading1.close();
            }
          })
          .catch(err => {
            return Promise.reject(err);
          });
      } else {
        this.$message({
          message: 'Please select address!!!',
          type: 'warning'
        });
      }
    }
  },
  computed: {
    ...mapGetters([
      "getCheckGoodList",
      "getShoppingCart",
      "getCheckNum",
      "getTotalPrice",
      "getCheckGoods",
    ]),
  }
}
</script>

<style scoped>
.wrap {
  font-size: 16px;
  border-top: 1px solid #c7c7c7;
  margin-top: -1px;
  padding: 0 29px;
}

::-webkit-scrollbar {
  display: none;
}

::v-deep .el-breadcrumb__inner.is-link:hover {
  color: #000;
}

.tit {
  font-size: 20px;
  font-weight: bold;
  margin-top: 50px;
  padding-bottom: 13px;
  border-bottom: 1px solid #EAEAEA;
}

.info {
  /* height: 199px; */
  border: 1px solid #EAEAEA;
  border-radius: 15px;
}

.infotit {
  height: 46px;
  background-color: #EAEAEA;
  border-radius: 15px 15px 0 0;
  padding-left: 32px;
  font-size: 17px;
  font-weight: bold;
  line-height: 46px;
}

.infotits {
  font-size: 12px;
  color: #959595;
  margin-bottom: 6px;
}

.infodetails {
  color: #545454;
  font-size: 15px;
}

.add {
  margin-left: 10px;
  color: #4583E1;
  font-size: 12px;
  text-decoration: underline;
}

.addlist {
  width: 277px;
  border-radius: 10px;
  border: 1px solid #D9D9D9;
  padding-left: 15px;
  padding-bottom: 24px;
}

.adds {
  margin-top: 19px;
  height: 62px;
  display: flex;
  color: #545454;
  border-bottom: 1px solid #D9D9D9;
}

.scrollable-content {
  width: 100%;
  height: 43.2vw;
  overflow: auto;
  scrollbar-color: #959595 transparent;
  scrollbar-width: thin;
  -ms-overflow-style: none;
}

.scrollable-content::-webkit-scrollbar-thumb {
  background-color: #959595;
  border-radius: 6px;
}

.scrollable-content::-webkit-scrollbar-track {
  background-color: transparent;
  border: none;
}

.scrollable-content::-webkit-scrollbar-button {
  color: transparent;
}

.addnew {
  width: 99px;
  font-size: 16px;
  color: #4583E1;
  background-color: #95C0FF;
  border-radius: 5px;
  border: none;
}

.save {
  width: 64px;
  height: 33px;
  font-size: 12px;
  color: #4583E1;
  background-color: #95C0FF;
  border-radius: 5px;
  cursor: pointer;
  border: none;
}

.grayed-out {
  opacity: 0.38;
  pointer-events: none;
}

::v-deep .el-loading-spinner {
  font-size: 80px;
}

::v-deep .custom-loading .el-loading-text {
  font-size: 30px;
  font-weight: bold;
}
</style>